import Vue from 'vue'
import { updateField } from 'vuex-map-fields'
import { getField } from 'vuex-map-fields'

export const actions = {
  openPanel({ state }) {
    if (state.panel_open) return Vue.noty.error('Video is already open. Please close it to open a new one.')
    state.panel_open = true
  },
  closePanel({ state }) {
    state.panel_open = false
  },
}

export const getters = {
  getField,
}

export const mutations = {
  updateField,
  openVideo(state, to) {
    state.video.to = to
    state.panel_open = true
  }
}

export const state = () => ({
  panel_open: false,
  video: {
    videoID: null,
    to_id: null,
    to_name: null,
    from_id: null,
    from_name: null
  }
})
